import { ArrowLeft } from "lucide-react";

export default function AvisoLegal() {
  return (
    <main className="min-h-screen px-6 py-16" style={{ background: "var(--bg)" }} data-testid="legal-page">
      <div className="mx-auto max-w-3xl">
        <a href="/" className="inline-flex items-center gap-2 text-sm font-semibold" style={{ color: "var(--mint-dark)" }} data-testid="legal-back-link">
          <ArrowLeft size={16} /> Volver a la página principal
        </a>

        <h1 className="mt-8 font-display font-extrabold tracking-tighter text-4xl sm:text-5xl" style={{ color: "var(--text-dark)" }}>
          Aviso Legal
        </h1>

        <p className="mt-6 text-base leading-relaxed" style={{ color: "var(--text-muted)" }}>
          Los tratamientos odontológicos que se ofrecen en este sitio son realizados por estudiantes de la Licenciatura en
          Cirujano Dentista de la Facultad de Odontología de la Universidad Autónoma de Tlaxcala (UATx), en su Clínica de
          Atención Bucal (Lira y Ortega S/N, Tlaxcala, Tlax.), bajo la supervisión y responsabilidad de dicha institución y de
          su personal clínico responsable, en apego a la Norma Oficial Mexicana NOM-004-SSA3-2012 del expediente clínico.
          Previo a cualquier procedimiento, el/la paciente recibe información completa y firma una carta de consentimiento
          informado en las instalaciones de la clínica.
        </p>
      </div>
    </main>
  );
}
